export default {
  // 国庆活动信息
  GET_NATIONAL_DAY_PAGE_INFO: '/NationalDay/ProvinceList',
  // 国庆省份活动信息
  GET_NATIONAL_DAY_PROVINCE_INFO: '/NationalDay/ProvinceInfo',
};
